/* UTV Wholesaler Journal — article + blog interactivity */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function slug(t) {
    return (t || '').toLowerCase().replace(/&[a-z]+;/g, '').replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-').slice(0, 64) || 'section';
  }
  function stickyOffset() {
    var h = $('.section-header .header-wrapper') || $('sticky-header') || $('.shopify-section-header-sticky');
    var off = 0;
    if (h) {
      var r = h.getBoundingClientRect();
      if (r.bottom > 0 && r.top <= 0 + 2) off = Math.max(0, r.bottom);
    }
    d.documentElement.style.setProperty('--uj-sticky', off + 'px');
    return off;
  }
  function toast(msg) {
    var t = $('.uj-toast');
    if (!t) { t = d.createElement('div'); t.className = 'uj-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    var ta = d.createElement('textarea'); ta.value = text; d.body.appendChild(ta); ta.select();
    try { d.execCommand('copy'); } catch (e) {}
    ta.remove(); return Promise.resolve();
  }
  function reveal(root) {
    var els = $$('.uj-reveal', root);
    if (!('IntersectionObserver' in w) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- ARTICLE ---------------- */
  function initArticle(root) {
    var body = $('[data-uj-body]', root);
    if (!body) return;

    // wrap tables, strip junk attributes from pasted docs
    $$('table', body).forEach(function (t) {
      if (t.parentNode.classList.contains('uj-tablewrap')) return;
      var wr = d.createElement('div'); wr.className = 'uj-tablewrap'; t.parentNode.insertBefore(wr, t); wr.appendChild(t);
    });
    $$('[bis_size]', body).forEach(function (e) { e.removeAttribute('bis_size'); });

    // FAQ: find the FAQ h2 and convert following h3/h4 + answers into accordions
    var heads = $$('h2', body);
    heads.forEach(function (h2) {
      if (!/faq|frequently asked|common questions/i.test(h2.textContent)) return;
      var items = [], el = h2.nextElementSibling, cur = null;
      while (el && el.tagName !== 'H2') {
        var next = el.nextElementSibling;
        if (el.tagName === 'H3' || el.tagName === 'H4' || (el.tagName === 'P' && el.children.length === 1 && el.firstElementChild.tagName === 'STRONG' && /\?\s*$/.test(el.textContent))) {
          cur = { q: el, a: [] }; items.push(cur);
        } else if (cur) { cur.a.push(el); }
        el = next;
      }
      if (items.length < 2) return;
      var wrap = d.createElement('div'); wrap.className = 'uj-faq';
      items.forEach(function (it, i) {
        var det = d.createElement('details'); if (i === 0) det.open = true;
        var sum = d.createElement('summary');
        var sp = d.createElement('span'); sp.textContent = it.q.textContent.trim();
        var ic = d.createElement('i'); ic.setAttribute('aria-hidden', 'true');
        sum.appendChild(sp); sum.appendChild(ic);
        var ans = d.createElement('div'); ans.className = 'uj-faq__a';
        it.a.forEach(function (n) { ans.appendChild(n); });
        det.appendChild(sum); det.appendChild(ans); wrap.appendChild(det);
        it.q.remove();
      });
      h2.parentNode.insertBefore(wrap, h2.nextSibling);
    });

    // headings -> ids + anchor links
    var used = {};
    var chapters = $$('h2', body).filter(function (h) { return h.textContent.trim().length > 1; });
    $$('h2, h3', body).forEach(function (h) {
      var id = h.id || slug(h.textContent);
      while (used[id]) id += '-2';
      used[id] = 1; h.id = id;
      var a = d.createElement('a'); a.href = '#' + id; a.className = 'uj-anchor'; a.setAttribute('aria-label', 'Link to this section'); a.textContent = '#';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var url = location.href.split('#')[0] + '#' + id;
        history.replaceState(null, '', '#' + id);
        copy(url).then(function () { toast('Link to section copied'); });
      });
      h.appendChild(a);
    });

    // inline product block after the 2nd chapter (or 1st if short)
    var tpl = $('template[data-uj-inline]', root);
    if (tpl && chapters.length) {
      var target = chapters[Math.min(chapters.length - 1, chapters.length > 3 ? 2 : 1)];
      if (target) {
        var frag = tpl.content.cloneNode(true);
        target.parentNode.insertBefore(frag, target);
      }
    }

    // chapter lists (desktop + mobile)
    var tocs = $$('[data-uj-toc]', root);
    var mbtnLabel = $('[data-uj-mtoc-label]', root);
    if (!chapters.length) {
      $$('[data-uj-toc-wrap]', root).forEach(function (n) { n.style.display = 'none'; });
    }
    var links = [];
    tocs.forEach(function (list) {
      var ol = d.createElement('ol');
      chapters.forEach(function (h, i) {
        var li = d.createElement('li'); var a = d.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.replace(/#$/, '').trim().replace(/^\d+[.)]\s+/, '');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var y = h.getBoundingClientRect().top + w.pageYOffset - stickyOffset() - 64;
          w.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
          history.replaceState(null, '', '#' + h.id);
          var m = $('.uj-mtoc', root); if (m) { m.classList.remove('is-open'); var b = $('button', m); if (b) b.setAttribute('aria-expanded', 'false'); }
        });
        li.appendChild(a); ol.appendChild(li); links.push({ a: a, h: h, i: i });
      });
      list.appendChild(ol);
    });
    $$('[data-uj-count]', root).forEach(function (n) { n.textContent = chapters.length + (chapters.length === 1 ? ' chapter' : ' chapters'); });

    var mt = $('.uj-mtoc', root);
    if (mt) {
      var mb = $('button', mt);
      mb.addEventListener('click', function () {
        var open = mt.classList.toggle('is-open');
        mb.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // progress + scrollspy
    var bar = $('.uj-progress i');
    var pctEls = $$('[data-uj-pct]', root);
    var barEls = $$('[data-uj-bar]', root);
    var totop = $('.uj-totop');
    var ticking = false, lastActive = -2;
    function onScroll() {
      ticking = false;
      var off = stickyOffset();
      var r = body.getBoundingClientRect();
      var total = body.offsetHeight - w.innerHeight * 0.6;
      var p = Math.min(1, Math.max(0, (-r.top + off + 80) / Math.max(1, total)));
      if (bar) bar.style.setProperty('--p', p.toFixed(4));
      barEls.forEach(function (b) { b.style.setProperty('--p', p.toFixed(4)); });
      pctEls.forEach(function (e) { e.textContent = Math.round(p * 100) + '% read'; });
      var active = -1;
      for (var i = 0; i < chapters.length; i++) {
        if (chapters[i].getBoundingClientRect().top - off - 120 <= 0) active = i;
      }
      links.forEach(function (l) {
        l.a.classList.toggle('is-active', l.i === active);
        l.a.classList.toggle('is-read', l.i < active);
        if (l.i === active) l.a.setAttribute('aria-current', 'true'); else l.a.removeAttribute('aria-current');
      });
      if (active !== lastActive) {
        lastActive = active;
        var col = $('.uj-toc-col', root);
        var al = col && active >= 0 ? $('a', col)[active] : null;
        if (al && col.scrollHeight > col.clientHeight) {
          var top = al.offsetTop - col.clientHeight / 2;
          col.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      if (mbtnLabel) mbtnLabel.textContent = active >= 0 ? chapters[active].textContent.replace(/#$/, '').trim() : (mbtnLabel.getAttribute('data-default') || 'Jump to a chapter');
      if (totop) totop.classList.toggle('is-on', w.pageYOffset > 900);
    }
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    w.addEventListener('resize', onScroll);
    onScroll();
    if (totop) totop.addEventListener('click', function () { w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

    // lightbox
    var lb = null;
    $$('img', body).forEach(function (img) {
      if (img.closest('a') || img.closest('.uj-inline')) return;
      img.addEventListener('click', function () {
        if (!lb) {
          lb = d.createElement('div'); lb.className = 'uj-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Image preview');
          lb.innerHTML = '<img alt="">';
          lb.addEventListener('click', function () { lb.classList.remove('is-on'); });
          d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb) lb.classList.remove('is-on'); });
          d.body.appendChild(lb);
        }
        var big = img.currentSrc || img.src;
        $('img', lb).src = big.replace(/([?&])width=\d+/, '$1width=1800');
        $('img', lb).alt = img.alt || '';
        lb.classList.add('is-on');
      });
    });

    // share
    $$('[data-uj-copy]', root).forEach(function (b) {
      b.addEventListener('click', function () { copy(location.href.split('#')[0]).then(function () { toast('Link copied — share away'); }); });
    });
    $$('[data-uj-native]', root).forEach(function (b) {
      if (!navigator.share) { b.style.display = 'none'; return; }
      b.addEventListener('click', function () { navigator.share({ title: d.title, url: location.href.split('#')[0] }).catch(function () {}); });
    });

    // helpful vote (per browser)
    var hp = $('[data-uj-helpful]', root);
    if (hp) {
      var key = 'uj-helpful-' + hp.getAttribute('data-uj-helpful');
      var prev = null;
      try { prev = localStorage.getItem(key); } catch (e) {}
      function done(v) {
        $$('button', hp).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false'); });
        var th = $('.uj-helpful__thanks', hp); if (th) th.hidden = false;
      }
      if (prev) done(prev);
      $$('button', hp).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-v');
          try { localStorage.setItem(key, v); } catch (e) {}
          done(v);
          toast(v === 'yes' ? 'Thanks! Glad it helped.' : 'Thanks — we will keep improving it.');
        });
      });
    }

    // deep link on load
    if (location.hash && location.hash.length > 1) {
      var t = d.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (t) setTimeout(function () { w.scrollTo({ top: t.getBoundingClientRect().top + w.pageYOffset - stickyOffset() - 64 }); }, 60);
    }
  }

  /* ---------------- BLOG INDEX ---------------- */
  function initBlog(root) {
    var cards = $$('[data-uj-card]', root);
    if (!cards.length) return;
    var chips = $$('[data-uj-topic]', root);
    var input = $('[data-uj-q]', root);
    var count = $('[data-uj-count-out]', root);
    var empty = $('.uj-empty', root);
    var feat = $('[data-uj-featured]', root);
    var state = { t: 'all', q: '' };
    function apply() {
      var n = 0, q = state.q.toLowerCase().trim();
      cards.forEach(function (c) {
        var okT = state.t === 'all' || (' ' + c.getAttribute('data-topics') + ' ').indexOf(' ' + state.t + ' ') > -1;
        var okQ = !q || c.getAttribute('data-search').indexOf(q) > -1;
        var okF = !(c.hasAttribute('data-feat') && state.t === 'all' && !q);
        var show = okT && okQ && okF;
        if (show && c.classList.contains('is-hidden')) { c.classList.remove('is-in'); void c.offsetWidth; c.classList.add('is-in'); }
        c.classList.toggle('is-hidden', !show);
        if (show) { n++; c.classList.add('is-in'); }
      });
      if (count) count.textContent = n + (n === 1 ? ' guide' : ' guides');
      if (empty) empty.classList.toggle('is-on', n === 0);
      if (feat) feat.hidden = state.t !== 'all' || !!q;
      chips.forEach(function (ch) { ch.setAttribute('aria-pressed', ch.getAttribute('data-uj-topic') === state.t ? 'true' : 'false'); });
    }
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        state.t = ch.getAttribute('data-uj-topic');
        apply();
        try { history.replaceState(null, '', state.t === 'all' ? location.pathname : location.pathname + '?topic=' + state.t); } catch (e) {}
        var g = $('[data-uj-gridtop]', root);
        if (g && g.getBoundingClientRect().top < 0) w.scrollTo({ top: g.getBoundingClientRect().top + w.pageYOffset - stickyOffset() - 90, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (input) {
      input.addEventListener('input', function () { state.q = input.value; apply(); });
    }
    var m = /[?&]topic=([a-z0-9-]+)/.exec(location.search);
    if (m && chips.some(function (c) { return c.getAttribute('data-uj-topic') === m[1]; })) { state.t = m[1]; }
    apply();
    w.addEventListener('scroll', function () { stickyOffset(); }, { passive: true });
    stickyOffset();
  }

  function init() {
    $$('[data-uj-article]').forEach(initArticle);
    $$('[data-uj-blog]').forEach(initBlog);
    reveal(d);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
